import React, { useEffect } from 'react'

import CarouselCustom from '../components/CarouselCustom/CategoryCarousel';
import BannerSection from '../components/BannerSection';
import NewlyArrivedBrands from '../components/NewlyArrivedBrands';
import TrendingProducts from '../components/TrendingProducts';
import BestSellingProducts from '../components/BestSellingProducts';
import ProductCarousel from '../components/ProductCarousel';
import { Link } from 'react-router-dom';
import Topcategories from '../components/Topcategories';
import CategoryCarousel1 from '../components/CarouselCustom/CategoryCarousel1';
import GridBanner from '../components/GridBanner';
import GridBanner1 from '../components/GridBanner1';
export default function Home() {
   const token = localStorage.getItem("token"); 
   const productImages1 = [
    "thumb-tomatoes.png",
    "thumb-tomatoketchup.png",
    "thumb-bananas.png",
    "thumb-bananas.png",
    "thumb-tomatoes.png",
    "thumb-tomatoketchup.png",
    "thumb-bananas.png",
    "thumb-bananas.png",
  ];

 useEffect(() => {  
    console.log("Token on Home page:", token);
  }, []); 
  const productImages2 = [
    "thumb-bananas.png",
    "thumb-tomatoketchup.png",
    "thumb-tomatoes.png",
    "thumb-bananas.png",
    "thumb-tomatoes.png",
    "thumb-bananas.png",
    "thumb-tomatoketchup.png",
    "thumb-bananas.png",
  ];
  return (
    <>
    <BannerSection />

    <NewlyArrivedBrands />

    <Topcategories/>
    
    {/* < CategoryCarousel1/> */}

    <GridBanner/>

    <CarouselCustom />

    <GridBanner1 />

    {/* <TrendingProducts /> */}

    {/* <section className="py-5">
      <div className="container-fluid">
        <div className="row">
          
          <div className="col-md-6">
            <div className="banner-ad bg-danger mb-3" style={{background: "url('images/ad-image-3.png')", backgroundRepeat: "no-repeat", backgroundPosition: "right bottom"}}>
              <div className="banner-content p-5">

                <div className="categories text-primary fs-3 fw-bold">Upto 25% Off</div>
                <h3 className="banner-title">Luxa Dark Chocolate</h3>
                <p>Very tasty & creamy vanilla flavour creamy muffins.</p>
                <Link to="#" className="btn btn-dark text-uppercase">Show Now</Link>

              </div>
            
            </div>
          </div>
          <div className="col-md-6">
            <div className="banner-ad bg-info" style={{background: "url('images/ad-image-4.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'right bottom'}}>
              <div className="banner-content p-5">

                <div className="categories text-primary fs-3 fw-bold">Upto 25% Off</div>
                <h3 className="banner-title">Creamy Muffins</h3>
                <p>Very tasty & creamy vanilla flavour creamy muffins.</p>
                <Link to="#" className="btn btn-dark text-uppercase">Show Now</Link>

              </div>
            
            </div>
          </div>
             
        </div>
      </div>
    </section> */}

    {/* <BestSellingProducts /> */}

        {/* <section className="py-5">
      <div className="container-fluid">

        <div className="bg-secondary py-5 my-5 rounded-5" style={{background: "url('images/bg-leaves-img-pattern.png') no-repeat"}}>
          <div className="container my-5">
            <div className="row">
              <div className="col-md-6 p-5">
                <div className="section-header">
                  <h2 className="section-title display-4">Get <span className="text-primary">25% Discount</span> on your first purchase</h2>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictumst amet, metus, sit massa posuere maecenas. At tellus ut nunc amet vel egestas.</p>
              </div>
              <div className="col-md-6 p-5">
                <form>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text"
                      className="form-control form-control-lg" name="name" id="name" placeholder="Name"/>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control form-control-lg" name="email" id="email" placeholder="abc@mail.com"/>
                  </div>
                  <div className="form-check form-check-inline mb-3">
                    <label className="form-check-label" htmlFor="subscribe">
                    <input className="form-check-input" type="checkbox" id="subscribe" value="subscribe"/>
                    Subscribe to the newsletter</label>
                  </div>
                  <div className="d-grid gap-2">
                    <button type="submit" className="btn btn-dark btn-lg">Submit</button>
                  </div>
                </form>
                
              </div>
              
            </div>
            
          </div>
        </div>
        
      </div>
    </section> */}
{/* 
    <ProductCarousel title="Most popular products" productImages={productImages1} />
    <ProductCarousel title="Just Arrived" productImages={productImages2} /> */}

        {/* <section id="latest-blog" className="py-5">
      <div className="container-fluid">
        <div className="row">
          <div className="section-header d-flex align-items-center justify-content-between my-5">
            <h2 className="section-title">Our Recent Blog</h2>
            <div className="btn-wrap align-right">
              <Link to="#" className="d-flex align-items-center nav-link">Read All Articles <svg width="24" height="24"><use href="#arrow-right"></use></svg></Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <article className="post-item card border-0 shadow-sm p-3">
              <div className="image-holder zoom-effect">
                <Link to="#">
                  <img src="images/post-thumb-1.jpg" alt="post" className="card-img-top"/>
                </Link>
              </div>
              <div className="card-body">
                <div className="post-meta d-flex text-uppercase gap-3 my-2 align-items-center">
                  <div className="meta-date"><svg width="16" height="16"><use href="#calendar"></use></svg>22 Aug 2021</div>
                  <div className="meta-categories"><svg width="16" height="16"><use href="#category"></use></svg>tips & tricks</div>
                </div>
                <div className="post-header">
                  <h3 className="post-title">
                    <Link to="#" className="text-decoration-none">Top 10 casual look ideas to dress up your kids</Link>
                  </h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipi elit. Aliquet eleifend viverra enim tincidunt donec quam. A in arcu, hendrerit neque dolor morbi...</p>
                </div>
              </div>
            </article>
          </div>
          <div className="col-md-4">
            <article className="post-item card border-0 shadow-sm p-3">
              <div className="image-holder zoom-effect">
                <Link to="#">
                  <img src="images/post-thumb-2.jpg" alt="post" className="card-img-top"/>
                </Link>
              </div>
              <div className="card-body">
                <div className="post-meta d-flex text-uppercase gap-3 my-2 align-items-center">
                  <div className="meta-date"><svg width="16" height="16"><use href="#calendar"></use></svg>25 Aug 2021</div>
                  <div className="meta-categories"><svg width="16" height="16"><use href="#category"></use></svg>trending</div>
                </div>
                <div className="post-header">
                  <h3 className="post-title">
                    <Link to="#" className="text-decoration-none">Latest trends of wearing street wears supremely</Link>
                  </h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipi elit. Aliquet eleifend viverra enim tincidunt donec quam. A in arcu, hendrerit neque dolor morbi...</p>
                </div>
              </div>
            </article>
          </div>
          <div className="col-md-4">
            <article className="post-item card border-0 shadow-sm p-3">
              <div className="image-holder zoom-effect">
                <Link to="#">
                  <img src="images/post-thumb-3.jpg" alt="post" className="card-img-top"/>
                </Link>
              </div>
              <div className="card-body">
                <div className="post-meta d-flex text-uppercase gap-3 my-2 align-items-center">
                  <div className="meta-date"><svg width="16" height="16"><use href="#calendar"></use></svg>28 Aug 2021</div>
                  <div className="meta-categories"><svg width="16" height="16"><use href="#category"></use></svg>inspiration</div>
                </div>
                <div className="post-header">
                  <h3 className="post-title">
                    <Link to="#" className="text-decoration-none">10 Different Types of comfortable clothes ideas for women</Link>
                  </h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipi elit. Aliquet eleifend viverra enim tincidunt donec quam. A in arcu, hendrerit neque dolor morbi...</p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

        <section className="py-5 my-5">
      <div className="container-fluid">

        <div className="bg-warning py-5 rounded-5" style={{ backgroundImage: "url('images/bg-pattern-2.png') no-repeat" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <img src="images/phone.png" alt="phone" className="image-float img-fluid"/>
              </div>
              <div className="col-md-8">
                <h2 className="my-5">Shop faster with foodmart App</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sagittis sed ptibus liberolectus nonet psryroin. Amet sed lorem posuere sit iaculis amet, ac urna. Adipiscing fames semper erat ac in suspendisse iaculis. Amet blandit tortor praesent ante vitae. A, enim pretiummi senectus magna. Sagittis sed ptibus liberolectus non et psryroin.</p>
                <div className="d-flex gap-2 flex-wrap">
                  <img src="images/app-store.jpg" alt="app-store"/>
                  <img src="images/google-play.jpg" alt="google-play"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>


        <section className="py-5">
      <div className="container-fluid">
        <h2 className="my-5">People are also looking for</h2>
        <Link to="#" className="btn btn-warning me-2 mb-2">Blue diamon almonds</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Angie’s Boomchickapop Corn</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Salty kettle Corn</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chobani Greek Yogurt</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Sweet Vanilla Yogurt</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Foster Farms Takeout Crispy wings</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Warrior Blend Organic</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chao Cheese Creamy</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chicken meatballs</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Blue diamon almonds</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Angie’s Boomchickapop Corn</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Salty kettle Corn</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chobani Greek Yogurt</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Sweet Vanilla Yogurt</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Foster Farms Takeout Crispy wings</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Warrior Blend Organic</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chao Cheese Creamy</Link>
        <Link to="#" className="btn btn-warning me-2 mb-2">Chicken meatballs</Link>
      </div>
    </section> */}

        <section className="py-5">
      <div className="container-fluid">
        <div className="row row-cols-1 row-cols-sm-3 row-cols-lg-5">
          <div className="col">
            <div className="card mb-3 border-0">
              <div className="row">
                <div className="col-md-2 text-dark">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M21.5 15a3 3 0 0 0-1.9-2.78l1.87-7a1 1 0 0 0-.18-.87A1 1 0 0 0 20.5 4H6.8l-.33-1.26A1 1 0 0 0 5.5 2h-2v2h1.23l2.48 9.26a1 1 0 0 0 1 .74H18.5a1 1 0 0 1 0 2h-13a1 1 0 0 0 0 2h1.18a3 3 0 1 0 5.64 0h2.36a3 3 0 1 0 5.82 1a2.94 2.94 0 0 0-.4-1.47A3 3 0 0 0 21.5 15Zm-3.91-3H9L7.34 6H19.2ZM9.5 20a1 1 0 1 1 1-1a1 1 0 0 1-1 1Zm8 0a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/></svg>
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0">
                    <h5>Free delivery</h5>
                    <p className="card-text">Get your healthcare products delivered safely to your doorstep absolutely free!</p>
                  </div>
                </div>
              </div>
              </div>
          </div>
          <div className="col">
            <div className="card mb-3 border-0">
              <div className="row">
                <div className="col-md-2 text-dark">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M19.63 3.65a1 1 0 0 0-.84-.2a8 8 0 0 1-6.22-1.27a1 1 0 0 0-1.14 0a8 8 0 0 1-6.22 1.27a1 1 0 0 0-.84.2a1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78ZM18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39a10 10 0 0 0 6 1.39Zm-4.46-2.29l-2.69 2.7l-.89-.9a1 1 0 0 0-1.42 1.42l1.6 1.6a1 1 0 0 0 1.42 0L15 11a1 1 0 0 0-1.42-1.42Z"/></svg>
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0">
                    <h5>100% secure payment</h5>
                    <p className="card-text">Shop confidently with our safe and encrypted payment system.</p>
                  </div>
                </div>
              </div>
              </div>
          </div>
          <div className="col">
            <div className="card mb-3 border-0">
              <div className="row">
                <div className="col-md-2 text-dark">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M22 5H2a1 1 0 0 0-1 1v4a3 3 0 0 0 2 2.82V22a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9.18A3 3 0 0 0 23 10V6a1 1 0 0 0-1-1Zm-7 2h2v3a1 1 0 0 1-2 0Zm-4 0h2v3a1 1 0 0 1-2 0ZM7 7h2v3a1 1 0 0 1-2 0Zm-3 4a1 1 0 0 1-1-1V7h2v3a1 1 0 0 1-1 1Zm10 10h-4v-2a2 2 0 0 1 4 0Zm5 0h-3v-2a4 4 0 0 0-8 0v2H5v-8.18a3.17 3.17 0 0 0 1-.6a3 3 0 0 0 4 0a3 3 0 0 0 4 0a3 3 0 0 0 4 0a3.17 3.17 0 0 0 1 .6Zm2-11a1 1 0 0 1-2 0V7h2ZM4.3 3H20a1 1 0 0 0 0-2H4.3a1 1 0 0 0 0 2Z"/></svg>
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0">
                    <h5>Quality guarantee</h5>
                    <p className="card-text">We provide only trusted and certified medical products because your health deserves the best.</p>
                  </div>
                </div>
              </div>
              </div>
          </div>
          <div className="col">
            <div className="card mb-3 border-0">
              <div className="row">
                <div className="col-md-2 text-dark">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8.35a3.07 3.07 0 0 0-3.54.53a3 3 0 0 0 0 4.24L11.29 16a1 1 0 0 0 1.42 0l2.83-2.83a3 3 0 0 0 0-4.24A3.07 3.07 0 0 0 12 8.35Zm2.12 3.36L12 13.83l-2.12-2.12a1 1 0 0 1 0-1.42a1 1 0 0 1 1.41 0a1 1 0 0 0 1.42 0a1 1 0 0 1 1.41 0a1 1 0 0 1 0 1.42ZM12 2A10 10 0 0 0 2 12a9.89 9.89 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20Zm0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20Z"/></svg>
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0">
                    <h5>guaranteed savings</h5>
                    <p className="card-text">Get the best medical products at prices that care for your health and your wallet.</p>
                  </div>
                </div>
              </div>
              </div>
          </div>
          <div className="col">
            <div className="card mb-3 border-0">
              <div className="row">
                <div className="col-md-2 text-dark">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M18 7h-.35A3.45 3.45 0 0 0 18 5.5a3.49 3.49 0 0 0-6-2.44A3.49 3.49 0 0 0 6 5.5A3.45 3.45 0 0 0 6.35 7H6a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1h1v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-6h1a1 1 0 0 0 1-1v-2a3 3 0 0 0-3-3Zm-7 13H8a1 1 0 0 1-1-1v-6h4Zm0-9H5v-1a1 1 0 0 1 1-1h5Zm0-4H9.5A1.5 1.5 0 1 1 11 5.5Zm2-1.5A1.5 1.5 0 1 1 14.5 7H13ZM17 19a1 1 0 0 1-1 1h-3v-7h4Zm2-8h-6V9h5a1 1 0 0 1 1 1Z"/></svg>
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0">
                    <h5>Daily offers</h5>
                    <p className="card-text">Shop today and grab exclusive deals on your favorite Medicare essentials!</p>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </section>



    </>
  )
}
